import { Request } from 'lib/generated/graphql';
import { DateTime } from 'luxon';
import { useRef, useState } from 'react';
import { EditButton, Modal, Tags } from 'src/shared-components';
import UpdateProject from 'src/shared-components/HuddleCard/Huddle/components/UpdateProject';
import Brief from '../shared/Brief';
import CompanyInfo from '../shared/CompanyInfo';
import HuddleTags from '../shared/HuddleTags';
import PartnerHeader from './components/PartnerHeader';
import RequestStatusHeader from './components/RequestStatusHeader';

const RequestCard = ({ request, partnerView = false }: { request: Request; partnerView?: boolean }) => {
  const [currentUpdateSection, setCurrentUpdateSection] = useState<string>('');
  const modalUpdateRef = useRef<any>();

  const goals = request?.goals?.filter(goal => goal.shown);

  const openModal = (section: string) => {
    setCurrentUpdateSection(section);
    modalUpdateRef.current.open();
  };

  return (
    <>
      {!partnerView && <RequestStatusHeader request={request} />}
      {partnerView && <PartnerHeader request={request} />}
      <div className={`bg-white flex flex-col p-6 rounded-xl rounded-tl-none rounded-tr-none drop-shadow`}>
        <div className={`block sm:flex mb-4`}>
          <CompanyInfo request={request} />
        </div>
        <div>
          <HuddleTags request={request} showIndustries openModal={openModal} showEditButton={!partnerView} />
        </div>
        <div>
          <Brief request={request} openModal={openModal} isCurrentUserAllowedToEdit showEditButton fullProjectView />
        </div>
        <div className="flex">
          <Tags tags={goals || []} size="md" color="gray" roundness="md" />
          {<EditButton onClick={() => openModal('goals')} />}
        </div>
        <span className="mt-8 text-[#797979] font-medium text-sm">
          Created {DateTime.fromISO(request.createdAt).toRelative()}
        </span>
        <Modal ref={modalUpdateRef}>
          <UpdateProject
            section={currentUpdateSection}
            request={request}
            onProjectUpdated={() => {
              modalUpdateRef.current?.close();
            }}
          />
        </Modal>
      </div>
    </>
  );
};

export default RequestCard;
